import { useApi } from '@/shared/api/http';

import type { ProductsQueryParams } from '@/entities/products/model/types/product';

export const useProductsService = () => {
  const api = useApi();

  const getAllProducts = async (params: ProductsQueryParams, isAuth = true) => {
    try {
      return await api.get<any>(`/products/list/`, isAuth, {
        params,
      });
    } catch (error) {
      console.error('Ошибка при получении массива продуктов:', error);
      throw error;
    }
  };

  const getProductBySlug = async (slug: string, isAuth = true) => {
    try {
      return await api.get<any>(`/products/detail/${slug}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при получении продукта:', error);
      throw error;
    }
  };

  const getCategoryBrands = async (categoryId: number, isAuth = false) => {
    try {
      return await api.get<any>(`/products/brands/by-category/${categoryId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при получении продукта:', error);
      throw error;
    }
  };

  const getMinMaxPrice = async (categoryId: number, isAuth = false) => {
    try {
      return await api.get<any>(`/products/price-range/${categoryId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при получении минимальной и максимальной цены:', error);
      throw error;
    }
  };

  const toggleFavorite = async (productId: string, isAuth = true) => {
    try {
      return await api.post<any>(`/products/mark-favorite/${productId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при добавлении в избранное:', error);
      throw error;
    }
  };

  return {
    getAllProducts,
    getProductBySlug,
    getCategoryBrands,
    getMinMaxPrice,
    toggleFavorite,
  };
};
